import ApiService from "../../ApiService";

const NewDefaultService = {
    loadScreenView: (successCallback, failureCallback) => {
        ApiService.post("/mobile/homework/newdefault/loadscreenview", { }, successCallback, failureCallback);
    }
};

export default NewDefaultService;